// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__3Y3JO","itemTitle":"ClientEmergencyInfo_itemTitle__2pCEK","itemText":"ClientEmergencyInfo_itemText__3BzKa"};